

export type NavItem = {
    label: string;
    href?: string;
    children?: NavItem[];
    onClick?: () => void;
    manualId?: string;
    url?: string
};


export const AppBarMenus: NavItem[] = [
    { label: "FAQ", children: [] },
    { label: "ERP", children: [] },
    { label: "Apps", children: [] },
    { label: "Portales", children: [] },
    { label: "Videos", href: "/videos" },
    { label: "Descargas", href: "/descargas" },
];

export const Categories = [
    {
      title: "Portales Web",
    },
    {
      title: "Software de Gestión",
    },
    {
      title: "Aplicaciones Móviles",
    },
];

export const FooterCategories = [
    {
      title: "Servicios",
    },
    {
      title: "Móviles",
    },
    {
      title: "Portales",
    },
];